import { createContext, useContext, useState, ReactNode } from "react";

interface SnackbarContextType {
  openSnackbar: (message: string, type?: "success" | "error" | "info") => void;
}

const SnackbarContext = createContext<SnackbarContextType | undefined>(undefined);

export function SnackbarProvider({ children }: { children: ReactNode }) {
  const [snackbar, setSnackbar] = useState<{
    message: string;
    type: "success" | "error" | "info";
    open: boolean;
  }>({ message: "", type: "info", open: false });

  const openSnackbar = (message: string, type: "success" | "error" | "info" = "info") => {
    setSnackbar({ message, type, open: true });
    // Auto-close after 3 seconds
    setTimeout(() => {
      setSnackbar(prev => ({ ...prev, open: false }));
    }, 3000);
  };

  return (
    <SnackbarContext.Provider value={{ openSnackbar }}>
      {children}
      {snackbar.open && (
        <div
          className={`fixed bottom-4 right-4 p-4 rounded-md shadow-lg z-50 ${
            snackbar.type === "error"
              ? "bg-red-500 text-white"
              : snackbar.type === "success"
              ? "bg-green-500 text-white"
              : "bg-blue-500 text-white"
          }`}
        >
          {snackbar.message}
        </div>
      )}
    </SnackbarContext.Provider>
  );
}

export function useSnackbar() {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error("useSnackbar must be used within a SnackbarProvider");
  }
  return context;
}